exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".switch{background:#fff;border:1px solid #dfdfdf;position:relative;display:inline-block;box-sizing:content-box;overflow:visible;width:52px;height:30px;padding:0;margin:0;border-radius:20px;cursor:pointer;box-shadow:inset 0 0 0 0 #dfdfdf;transition:all .3s ease-out;-webkit-transition:all .3s ease-out;top:-1px}.switch.wide{width:80px}.switch small{background:#fff;border-radius:100%;box-shadow:0 1px 3px rgba(0,0,0,.4);width:30px;height:30px;position:absolute;top:0;left:0;transition:all .3s ease-out;-webkit-transition:all .3s ease-out}.switch.checked{background:#64bd63;border-color:#64bd63}.switch.checked small{left:22px}.switch.wide.checked small{left:52px}.switch .switch-text{font-family:Arial,Helvetica,sans-serif;font-size:13px}.switch .off{display:block;right:10%;color:#a9a9a9}.switch .off,.switch .on{position:absolute;top:25%;z-index:0}.switch .on{color:#fff;left:9%}.switch.checked .off,.switch .on{display:none}.switch.checked .on{display:block}.switch.disabled{opacity:.5;cursor:not-allowed}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./bower_components/angular-ui-switch/angular-ui-switch.css
 ** module id = 33
 ** module chunks = 0
 **/